import React from "react";
import Navbar from "../components/Navbar";
import SiteFooter from "../components/SiteFooter";

const sectionStyle: React.CSSProperties = { marginBottom: 40 };
const h2Style: React.CSSProperties = {
  fontFamily: "Syne, sans-serif",
  fontSize: 18,
  fontWeight: 700,
  color: "#fff",
  marginBottom: 10,
};
const pStyle: React.CSSProperties = {
  fontSize: 14,
  color: "rgba(255,255,255,0.55)",
  lineHeight: 1.8,
};

const PrivacyPage: React.FC = () => {
  return (
    <div style={{ background: "var(--nx-navy)", minHeight: "100vh" }}>
      <Navbar variant="solid" />

      <section style={{ padding: "160px 5% 100px", maxWidth: 800, margin: "0 auto" }}>
        <span className="nx-badge nx-badge-blue" style={{ marginBottom: 20 }}>
          Legal
        </span>
        <h1
          style={{
            fontFamily: "Syne, sans-serif",
            fontSize: "clamp(26px, 4vw, 40px)",
            fontWeight: 800,
            color: "#fff",
            letterSpacing: "-0.03em",
            marginBottom: 8,
          }}
        >
          Privacy Policy
        </h1>
        <p style={{ fontSize: 12, color: "rgba(255,255,255,0.35)", marginBottom: 48 }}>
          Last updated: {new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}
        </p>

        <div style={sectionStyle}>
          <h2 style={h2Style}>1. Overview</h2>
          <p style={pStyle}>
            Nexora, built by Pentagon Analytics LLP ("Pentagon Analytics", "we", "us"),
            respects your privacy. This policy explains what information we
            collect when you use the Nexora website and platform, how we use
            it, and the choices available to you and your community.
          </p>
        </div>

        <div style={sectionStyle}>
          <h2 style={h2Style}>2. Information We Collect</h2>
          <p style={pStyle}>
            We collect account information (name, email, phone, society
            details) provided during signup and Request Access submissions,
            resident and community data entered by society admins and staff
            to operate the platform, and general usage data to improve
            Nexora's performance and reliability.
          </p>
        </div>

        <div style={sectionStyle}>
          <h2 style={h2Style}>3. How We Use Information</h2>
          <p style={pStyle}>
            Information is used to provide and support the Nexora platform,
            respond to inquiries, and meet legal and contractual obligations.
            We do not sell personal information to third parties.
          </p>
        </div>

        <div style={sectionStyle}>
          <h2 style={h2Style}>4. Data Security</h2>
          <p style={pStyle}>
            We apply role-based access controls, encryption in transit, and
            audit logging to protect resident and community data handled by
            Nexora.
          </p>
        </div>

        <div style={sectionStyle}>
          <h2 style={h2Style}>5. Your Rights</h2>
          <p style={pStyle}>
            You may request access to, correction of, or deletion of your
            personal data by contacting{" "}
            <a href="mailto:nexora@pentagonanalytics.io" style={{ color: "var(--nx-blue-light)" }}>
              nexora@pentagonanalytics.io
            </a>
            .
          </p>
        </div>

        <div style={sectionStyle}>
          <h2 style={h2Style}>6. Contact</h2>
          <p style={pStyle}>
            Questions about this policy can be directed to{" "}
            <a href="mailto:nexora@pentagonanalytics.io" style={{ color: "var(--nx-blue-light)" }}>
              nexora@pentagonanalytics.io
            </a>
            .
          </p>
        </div>
      </section>

      <SiteFooter />
    </div>
  );
};

export default PrivacyPage;
